// src/pages/RequestDemoPage.js
import React from 'react';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import RequestDemoCard from '../components/RequestDemoCard';

const RequestDemoPage = ({
  requestDemoLimit,
  setRequestDemoLimit,
  requestDemoRecords,
  loadingRequestDemos,
  fetchRequestDemos,
  filteredRequestDemos,
  handleEditRequestDemo
}) => {
  return (
    <Container className="mb-3 request-demo-section">
      <h2 className="mb-2">Promo Signups Management</h2>
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center py-2">
          <div>
            <small className="me-2">Records: {requestDemoLimit}</small>
            <input
              type="range"
              className="form-range d-inline-block"
              style={{ width: '150px' }}
              min="50"
              max="500"
              step="50"
              value={requestDemoLimit}
              onChange={(e) => setRequestDemoLimit(parseInt(e.target.value))}
            />
          </div>
          <Button
            variant="primary"
            size="sm"
            onClick={fetchRequestDemos}
            disabled={loadingRequestDemos}
          >
            {loadingRequestDemos ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
                Loading...
              </>
            ) : (
              'Fetch Signups'
            )}
          </Button>
        </Card.Header>
        <Card.Body className="py-2">
          {requestDemoRecords.length > 0 && (
            <Alert variant="info" className="py-2 mb-2">
              <small>Found {requestDemoRecords.length} signup records.</small>
            </Alert>
          )}

          {filteredRequestDemos.length > 0 ? (
            <div className="row">
              {filteredRequestDemos.map(record => (
                <div className="col-md-12" key={record.id}>
                  <RequestDemoCard
                    record={record}
                    onEdit={handleEditRequestDemo}
                  />
                </div>
              ))}
            </div>
          ) : (
            <Alert variant={loadingRequestDemos ? "warning" : "secondary"} className="py-2 mb-0">
              <small>
                {loadingRequestDemos
                  ? "Loading records..."
                  : "No records found. Click 'Fetch Signups' to load data."}
              </small>
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default RequestDemoPage;
